const baseFitmentFields = ['Year', 'Make', 'Model', 'Submodel'];
const extraFitmentFields = [];

function InitFunc() {
  if (window.document.body.classList.contains('home')) {
    const defaultVehicleBarEl = document.querySelector('#store .veh-bar');

    const mountPoint = window.document.createElement('div');
    mountPoint.innerHTML = `
      <div class="cm_home-page-search">
        <div id="cm-search-box-home"></div>
        <div id="cm-ymm-home"></div>
      </div>
    `;

    defaultVehicleBarEl?.replaceWith(mountPoint);
  }
}

const closeBurgerOnSearchPage = () => {
  if (window.location.pathname === '/search/' && document.querySelector('header .nav-links.open')) {
    document.querySelector('header .nav-links.open').classList.remove('open');
  }
};

function onVehicleSelected() {
  closeBurgerOnSearchPage();
}

export default {
  platform: 'woocommerce',
  searchPageUrl: '/search/',
  InitFunc,
  sortFields: ['relevance', 'total_sales:desc', 'name', 'name:desc', 'price', 'price:desc'],
  SearchRequestDefaults: {
    pageSize: 36,
  },
  fitmentSearch: {
    baseFields: baseFitmentFields,
    extraFields: extraFitmentFields,
    onVehicleSelected,
  },
  Widgets: [
    {
      name: 'SearchPage',
      location: '#cm_results',
      template: 'SearchPage',
    },
    {
      name: 'SearchResult',
    },
    {
      name: 'SearchHeader',
    },
    {
      name: 'FilterChips',
      type: 'FacetPanel',
    },
    {
      name: 'Facets',
      type: 'FacetPanel',
    },
    {
      name: 'SearchVehicleWidget',
      type: 'VehicleWidget',
      isVehicleSelectionIsolated: true,
    },
    {
      name: 'FacetPanelVehicleWidget',
      type: 'VehicleWidget',
      isAlwaysActive: true,
      isVehicleSelectionIsolated: true,
    },
    {
      name: 'SearchBox',
      location: {
        replace: '.wrap .nav-cta .hdr-search',
        class: 'cm_search-box-root_container',
      },
      template: 'SearchBox',
    },
    {
      name: 'HomeSearchBox',
      type: 'SearchBox',
      location: {
        selector: '#cm-search-box-home',
        class: 'cm_search-box-root__home',
      },
      template: 'SearchBox',
      disableDropdown: true,
    },
    {
      name: 'SearchBox_burger',
      type: 'SearchBox',
      location: {
        replace: 'header .wrap .nav-links form.nav-search',
        class: 'cm_search-box-root__burger cm_desktop-hide',
      },
      template: 'SearchBox',
      disableDropdown: true,
      onSubmit: () => {
        closeBurgerOnSearchPage();
      },
    },
    {
      name: 'FacetCategoryTiles',
      type: 'FacetTiles',
      location: '#cm_categories',
      facetField: 'turn_14_categories',
      template: 'facetTiles/hierarchicalContainer',
    },
    {
      name: 'HeaderVehicleWidget_burger',
      type: 'VehicleWidget',
      location: {
        insertAfter: 'header .wrap .nav-links form.nav-search, #cm_SearchBox_burger',
        class: 'cm_vehicle-widget__burger cm_desktop-hide',
      },
      template: 'fitmentSearch/collapsibleVehicleWidget',
      columnBreakpoint: 650,
      initCollapsed: true,
      isAlwaysColumnLayout: true,
    },
    {
      name: 'HomeVehicleWidget',
      type: 'VehicleWidget',
      template: 'fitmentSearch/homeVehicleWidget',
      location: {
        selector: '#cm-ymm-home',
        class: 'cm_vehicle-widget__homepage',
      },
      columnBreakpoint: 600,
    },
    {
      name: 'Garage',
      location: {
        insertBefore: '.wrap .nav-cta .btn-blue',
        class: 'cm_garage__desktop menu-item menu-item-type-post_type menu-item-object-page',
      },
      template: 'fitmentSearch/garage',
    },
    {
      name: 'VerifyFitment',
      location: {
        insertBefore: 'body.product-template-default form.cart',
      },
      template: 'fitmentSearch/verifyFitment',
      columnBreakpoint: 650,
    },
    {
      name: 'FitmentTable',
      location: {
        id: 'tab-fitment',
        class: 'woocommerce-Tabs-panel woocommerce-Tabs-panel--fitment panel entry-content wc-tab',
        insertAfter: 'body.product-template-default .woocommerce-Tabs-panel--description',
      },
      template: 'fitmentSearch/fitmentTable',
    },
    {
      name: 'FitmentTableTab',
      type: 'FitmentTable',
      location: {
        insertAfter: 'body.product-template-default .woocommerce-tabs .description_tab',
        wrapper: 'li',
        id: 'tab-title-fitment',
        class: 'fitment_tab',
      },
      template: 'fitmentSearch/fitmentTableTab',
    },
    {
      name: 'FacetDialog',
      template: 'FacetDialog',
    },
    {
      name: 'VehicleWidgetDialog',
      template: 'fitmentSearch/dialog',
    },
    {
      name: 'SearchBoxDialog',
      template: 'SearchBoxDialog',
    },
  ],
};
